import React from 'react';
import ReactTooltip from 'react-tooltip';
import {
	Loader,
	BaasicConfirmModal,
	TableFilter,
	BaasicTable,
	BaasicModal,
	BaasicCheckbox,
	BaasicHeader,
	BaasicSelect,
	BaasicTableExport,
} from 'core/components';
import { ProductStore } from 'modules/product/stores';
import { defaultTemplate } from 'core/hoc';
import { ProductImport } from 'modules/product/pages';
import { FileNames } from 'common/constants';

const ProductListTemplate = ({
	t,
	viewStore,
	viewStore: {
		loading,
		listStore,
		tableData,
		baasicTableSettingsViewStore,
		queryUtility,
		columnFilterSetup,
		deleteConfirmModal,
		linkProductConfirmModal,
		setProductActivityConfirmModal,
		removeFiltersModal: { removeFiltersConfirm },
		onCheck,
		showOnlyActiveSkus,
		showActions,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader
				title="MAINMENU.ADMINISTRATION.PRODUCTS"
				baasicTableSettingsViewStore={baasicTableSettingsViewStore}
			>
				<div className="flex--primary">
					<div>
						<BaasicCheckbox
							id={'showInactiveSkus'}
							onChange={onCheck}
							label="PRODUCTVIEW.SHOWINACTIVESKUS"
							checked={showOnlyActiveSkus}
							className="input--check input--check--negative"
						/>
					</div>
					<BaasicTableExport tableViewStore={viewStore} fileTitle={FileNames.Product} />
				</div>
			</BaasicHeader>
			<BaasicTable
				{...{
					tableData,
					queryUtility,
					viewStore,
					showActions,
				}}
				data={listStore.data.slice()}
				actions={viewStore}
			/>
			<TableFilter viewStore={viewStore} columnFilterSetup={columnFilterSetup} />
			<BaasicConfirmModal modalParams={deleteConfirmModal} />
			<BaasicConfirmModal modalParams={removeFiltersConfirm} />
			<BaasicConfirmModal modalParams={linkProductConfirmModal} />
			<BaasicConfirmModal modalParams={setProductActivityConfirmModal} />
			<BaasicModal modalParams={viewStore.importModal} className="ReactModal__Content ReactModal--med">
				<ProductImport />
			</BaasicModal>
			<ReactTooltip />
		</section>
	);
};

export default defaultTemplate(ProductListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/product/pages/ProductListTemplate.jsx